import React, { PureComponent } from "react";
import { NavLink } from "react-router-dom";

export default class TTNavComponent extends PureComponent {
  render() {
    const { label, url, icon } = this.props;

    return (
      <NavLink exact to={url} activeClassName="active">
        {icon ? <i icon className={`icon icon-${icon}`} /> : null}
        {label}
      </NavLink>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Menu/SubMenu/TTNavComponent.js